import merge from 'lodash/merge'

const state = {
  modals: []
}

const defaultState = {
  isValid: true,
  isLoading: false
}

const defaultAction = {
  isDisabled: () => false,
  isLoading: () => false
}

const actions = {
  showModal ({ commit }, payload) {
    const { component, state = {}, options = {}, events = {}, actions = [] } = payload
    const identifier = Math.random().toString(36).substring(2, 10)

    const defaultEvents = {
      hidden: () => commit('removeModal', identifier)
    }

    commit('addModal', { identifier, component, state: merge({ }, defaultState, state), options, events: merge({ }, defaultEvents, events), actions: actions.map(action => merge({ }, defaultAction, action)) })

    return identifier
  },

  updateModal ({ commit }, payload) {
    commit('updateModal', payload)
  },

  removeModal ({ commit }, identifier) {
    commit('removeModal', identifier)
  }
}

const mutations = {
  addModal (state, modal) {
    state.modals.push(modal)
  },

  updateModal (state, { identifier, data }) {
    state.modals = state.modals.map(item => item.identifier === identifier ? merge({ }, item, data) : item)
  },

  removeModal (state, identifier) {
    state.modals = state.modals.filter(item => item.identifier !== identifier)
  }
}

export default {
  state,
  actions,
  mutations
}
